import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Switch } from "./ui/switch";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { Bot, Gauge } from "lucide-react";
import { toast } from "sonner";

export default function AutopilotToggle() {
  const [s, setS] = useState(null);
  const [cap, setCap] = useState("");
  useEffect(() => { api.get("/admin/settings").then(({ data }) => { setS(data); setCap(String(data.concierge_daily_cap)); }).catch(() => setS({ ai_autopilot: false, concierge_daily_cap: 500, concierge_used_today: 0 })); }, []);
  const toggle = async (v) => {
    setS((x) => ({ ...x, ai_autopilot: v }));
    try { await api.patch("/admin/settings", { ai_autopilot: v }); toast.success(v ? "AI autopilot is answering for you" : "AI autopilot paused"); }
    catch { setS((x) => ({ ...x, ai_autopilot: !v })); toast.error("Could not update"); }
  };
  const saveCap = async () => {
    try { const { data } = await api.patch("/admin/settings", { concierge_daily_cap: Number(cap) }); setS(data); toast.success(`Raq capped at ${data.concierge_daily_cap} messages/day`); }
    catch { toast.error("Could not save cap"); }
  };
  return (
    <div className="grid md:grid-cols-2 gap-4">
      <div className="p-4 rounded-2xl bg-gradient-to-br from-cyan-500/10 to-blue-500/10 border border-cyan-500/30 flex items-center justify-between gap-4" data-testid="autopilot-card">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-xl bg-cyan-500/20 text-cyan-300 flex items-center justify-center shrink-0"><Bot className="w-5 h-5" /></div>
          <div>
            <p className="font-display font-bold">AI Autopilot</p>
            <p className="text-xs text-slate-400 mt-0.5">Claude answers every buyer message, trip chat and dispute reply on your behalf.</p>
          </div>
        </div>
        <Switch checked={!!s?.ai_autopilot} disabled={s === null} onCheckedChange={toggle} data-testid="autopilot-toggle" />
      </div>
      <div className="p-4 rounded-2xl bg-[#131722] border border-amber-500/30 flex items-center justify-between gap-4 flex-wrap" data-testid="concierge-cap-card">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-xl bg-amber-500/20 text-amber-300 flex items-center justify-center shrink-0"><Gauge className="w-5 h-5" /></div>
          <div>
            <p className="font-display font-bold">Raq daily spend cap</p>
            <p className="text-xs text-slate-400 mt-0.5">Public concierge messages per day. Used today: <span className="font-mono text-amber-300" data-testid="concierge-used-today">{s?.concierge_used_today ?? 0}</span> / {s?.concierge_daily_cap ?? "—"}</p>
          </div>
        </div>
        <div className="flex gap-2">
          <Input type="number" min={0} value={cap} onChange={(e) => setCap(e.target.value)} className="w-24 h-9 bg-[#0B0D12] border-slate-800 font-mono" data-testid="concierge-cap-input" />
          <Button size="sm" onClick={saveCap} className="h-9 bg-amber-400 text-slate-950 hover:bg-amber-300 font-semibold" data-testid="concierge-cap-save">Save</Button>
        </div>
      </div>
    </div>
  );
}
